import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { ITableColumn } from "src/app/shared/components/tables/datatable/datatable.component";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { RegioneSubmission } from "./models/regione-submission.model";


export const SUBMISSION_ENDPOINT = 'files';
export const SUBMISSION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(SUBMISSION_ENDPOINT);


export const submissionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}

export const LISTA_SUBMISSION_COLUMNS: any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'psaName',
    label: 'Nome PSA',
    field: 'psaName',
    type:'text'

  },
  {
    name: 'ValidityStateTypePsa',
    label: 'Stato del Psa',
    field: 'ValidityStateTypePsa',
    styles: (row: RegioneSubmission) => ({
      'background-color': VALIDITY_STATE_COLOR_MAP[row.ValidityStateTypePsa],
      'color': '#292727ff'
    }),
    cell: (row: RegioneSubmission) => row.ValidityStateTypePsa.replaceAll('_', ' ').toUpperCase(),
    type:'chips'
  },
  {
    name: 'practiceNumber',
    label: 'Numero Pratica',
    field: 'practiceNumber',
    type:'text'

  },

  {
    name: 'gestore',
    label: 'Gestore',
    field: 'gestore',
    type:'text'

  },

  {
    name: 'observationStatus',
    label: 'Stato OPSA',
    field: 'observationStatus',
    styles: (row: RegioneSubmission) => ({
      'background-color': OBSERVATION_STATUS_COLOR_MAP[row.observationStatus],
      'color': '#292727ff'
    }),
    cell: (row: RegioneSubmission) => row.observationStatus,
    type:'chips'

    
  },
  {
    name : "remainingDays",
    label:"Scadenza OPSA",
    field:"remainingDays",
    styles: (row: RegioneSubmission) => ({
      'background-color': row.remainingDays?.color,
      'color': '#fff'
    }),
    cell: (row: RegioneSubmission) => row.remainingDays?.days,
    type:'chips'
  },
  {
    name: 'submittedAt',
    label: 'Data trasmissione DPSA',
    field: 'submittedAt',
    type: 'date',

  },

  {
    name: 'updatedAt',
    label: 'Aggiornato il',
    field: 'updatedAt',
    type: 'date',

  }

];

export const LISTA_SUBMISSION_VISIBLECOLUMNS = [

  'psaName',
  'gestore',
  'practiceNumber',
  'ValidityStateTypePsa',
  'submittedAt',
  'observationStatus', 
  'remainingDays',
  'azioni'
];


export const LISTA_SUBMISSION_FILTER_COLUMNS: ITableColumn[] = [

  {
    name: 'validityState',
    label: 'Stato del Psa',
    field: 'validityState',
    type:'select',
    options: [
      
      { label: 'TRASMESSO', value: 'TRASMESSO' },
      { label: 'IN COMPILAZIONE', value: 'IN_COMPILAZIONE' },
      { label: 'IN VALUTAZIONE', value: 'IN_VALUTAZIONE' },
      { label: 'PSA CON GIUDIZIO EMESSO', value: 'PSA_CON_GIUDIZIO_EMESSO' },
    ]
  },
  {
    name: 'observationStatus',
    label: 'Stato OPSA',
    field: 'observationStatus',
    type:'select',
    options: [
      { label: 'DA COMPLETARE', value: 'DA COMPLETARE' },
      { label: 'COMPLETATO', value: 'COMPLETATO' },
    ]

  },
  {
    name: 'expired',
    label: 'Scadenza',
    field: 'expired',
    type:'select',
    options: [
      { label: 'SCADUTO', value: true },
      { label: 'NON SCADUTO', value: false },
    ]
  },
  {
    name: 'idArera',
    label: 'Gestore',
    field: 'idArera',
    type:'select',
    options: []

  },
];

export const OBSERVATION_STATUS_COLOR_MAP: any = {
  "DA COMPLETARE": "rgb(237 63 63)",
  "MODIFICABILE": "rgb(255 227 98)",
  "COMPLETATO": "rgb(51 203 51)"
}

export const VALIDITY_STATE_COLOR_MAP: any = {
  "TRASMESSO": "rgb(122 191 229)",
  "IN COMPILAZIONE": "rgb(201 201 201)",
  "IN VALUTAZIONE": "rgb(255 227 98)",
  "APPROVATO": "rgb(51 203 51)",
  "APPROVATO CON RISERVA": "rgb(255 184 99)",
  "NON APPROVATO": "rgb(237 63 63)",
  "PSA CON GIUDIZIO EMESSO": "rgb(51 203 51)"
}